import React from "react";
import "./VoiceRecognitionLoader.scss";

const VoiceRecognitionLoader = (props) => {
  return (
    <div id="voicebars">
      <div class="voicebar"></div>
      <div class="voicebar"></div>
      <div class="voicebar"></div>
      <div class="voicebar"></div>
      <div class="voicebar"></div>
      <div class="voicebar"></div>
      <div class="voicebar"></div>
      <div class="voicebar"></div>
      <div class="voicebar"></div>
      <div class="voicebar"></div>
    </div>
  );
};

export default VoiceRecognitionLoader;
